import { TextNode } from 'lexical';
import katex from 'katex';
import 'katex/dist/katex.min.css';

export class MathNode extends TextNode {
  static getType() {
    return 'math';
  }

  static clone(node) {
    return new MathNode(node.__text, node.__key);
  }

  createDOM(config) {
    const dom = document.createElement('span');
    dom.setAttribute('data-lexical-key', this.__key);

    const latex = this.getTextContent();
    dom.className = 'math-node';

    // Add tooltip attributes for react-tooltip
    dom.setAttribute('data-tooltip-id', 'math-tooltip');
    dom.setAttribute('data-tooltip-content', 'Click to edit the formula');

    // Render LaTeX using KaTeX
    katex.render(latex, dom, {
      throwOnError: false,
    });

    return dom;
  }

  updateDOM(prevNode, dom) {
    // Optional: update KaTeX content if it changes
    return false;
  }

  static importJSON(serializedNode) {
    return new MathNode(serializedNode.text, serializedNode.key);
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'math',
      text: this.getTextContent(),
    };
  }

  exportDOM(editor) {
    const element = document.createElement('span');
    element.className = 'math-node';
    element.innerHTML = `$$${this.getTextContent()}$$`;
    return { element };
  }
  // exportDOM(editor) {
  //   const element = document.createElement('span');
  //   element.className = 'math-node';
  //   element.textContent = `$$${this.getTextContent()}$$`;
  //   element.setAttribute('data-latex-raw', this.getTextContent());
  //   return { element };
  // }
  static importDOM() {
    return {
      span: (domNode) => {
        if (
          domNode.classList.contains('math-node') ||
          containsLatex(domNode.textContent)
        ) {
          return {
            conversion: convertMathAndTextNodes,
            priority: 1,
          };
        }
        return null;
      },
    };
  }
}

function convertMathAndTextNodes(domNode) {

  const raw = domNode.getAttribute('data-latex-raw');
  const latex = raw || extractLatex(domNode.textContent);

  if (!latex) return { node: null };

  return {
    node: new MathNode(latex),
    forChild: () => null,
  };
  // const nodes = [];
  // const parts = domNode.textContent.split(/(\$\$.*?\$\$)/);

  // parts.forEach((part) => {
  //   if (containsLatex(part)) {
  //     const latex = extractLatex(part);
  //     nodes.push(new MathNode(latex));
  //   } else if (part.trim().length > 0) {
  //     nodes.push(new TextNode(part.trim()));
  //   }
  // });

  // return {
  //   node: nodes.length === 1 ? nodes[0] : nodes,
  // };
}

function containsLatex(text) {
  return /\$\$(.*?)\$\$/.test(text);
}

function extractLatex(text) {
  const match = text.match(/\$\$(.*?)\$\$/);
  return match ? match[1] : '';
}
